import { render, staticRenderFns } from "./WorkStationEdit.vue?vue&type=template&id=0cc21b23&scoped=true&"
import script from "./WorkStationEdit.vue?vue&type=script&lang=js&"
export * from "./WorkStationEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkStationEdit.vue?vue&type=style&index=0&id=0cc21b23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc21b23",
  null
  
)

export default component.exports